import React, { Children, memo } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, CameraIcon, UsersIcon, ImageIcon, SmileIcon, ShareIcon } from 'lucide-react';
export const PhotoBoothPage = () => {
  const features = [{
    icon: SmileIcon,
    title: 'Toddler-Friendly',
    description: 'Specially designed for little ones with easy-to-use interface, colorful props, and engaging backdrops that capture their attention and imagination.'
  }, {
    icon: ShareIcon,
    title: 'Digital Sharing',
    description: 'Instantly share photos via text message, email, QR code, or directly to social media'
  }, {
    icon: ImageIcon,
    title: 'Fun Props',
    description: 'Wide selection of props to make your photos more fun and memorable'
  }, {
    icon: CameraIcon,
    title: 'Custom Templates',
    description: 'Personalized photo templates with your event details and custom designs'
  }];
  return <div className="bg-white w-full" data-id="element-868">
      <div className="relative overflow-hidden bg-gradient-to-r from-primary-50 via-secondary-50 to-primary-50" data-id="element-869">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-870">
          <div className="text-center mb-12" data-id="element-871">
            <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-872">
              Photo Booth Rental
            </h1>
            <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-873">
              Capture magical moments and create lasting memories with our
              premium selfie station
            </p>
            <div className="mt-8" data-id="element-874">
              <Link to="/cart" className="inline-flex items-center px-8 py-3 bg-secondary-500 text-white rounded-full font-medium text-lg shadow-lg hover:bg-secondary-600 transition-all" onClick={() => window.scrollTo(0, 0)} data-id="element-875">
                Book Now
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Main content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-876">
        {/* Photo booth overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20" data-id="element-877">
          <div className="flex justify-center" data-id="element-878">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uxtm2rKDZDafK4m5B7WVyR/IMG_3235.jpg" alt="Mother and child at photo booth with pink birthday background" className="rounded-xl shadow-xl w-4/5 h-auto mx-auto" data-id="element-879" />
          </div>
          <div data-id="element-880">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-881">
              Toddlers love photo booths too!
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-882">
              Our photo booth rental adds a burst of fun to any toddler
              celebration — from birthday parties to playdates and family
              gatherings. Kids light up when they see our colorful props and
              playful backdrops, and parents love capturing those silly, sweet
              moments.
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-883">
              We provide a full setup with an easy-to-use iPad selfie station,
              toddler-friendly props, adorable themed backdrops, and instant
              digital sharing. It's simple enough for little hands and fun for
              the whole family!
            </p>
            <div className="bg-secondary-50 rounded-lg p-6 border border-secondary-100" data-id="element-884">
              <h3 className="text-xl font-semibold text-primary-500 mb-3" data-id="element-885">
                Self-Service Photo Booth - Starting at $50/hr
              </h3>
              <p className="text-gray-700" data-id="element-886">
                Our self-service photo booth is perfect for any event. Easy to
                use with professional results, and includes digital sharing via
                text, email, QR code, or social media.
              </p>
            </div>
          </div>
        </div>
        {/* Gallery Section */}
        <div className="mb-20" data-id="element-887">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-888">
            A Variety Of Options To Explore
          </h2>
          <p className="text-center text-lg text-gray-600 mb-10 max-w-4xl mx-auto" data-id="element-889">
            From stylish backdrops to customizable digital scenes and fun
            boomerangs, our photo booth experiences bring every moment to life
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-890">
            <div className="relative rounded-lg overflow-hidden group" data-id="element-891">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7YzrPUpY45BN7ZBNsFq7SN/IMG_0270.jpg" alt="Family with balloon backdrop" className="w-full h-[500px] object-cover" data-id="element-892" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-500/70 via-primary-500/40 to-transparent p-6 flex flex-col justify-end" data-id="element-893">
                <h3 className="text-white text-xl font-bold mb-2" data-id="element-894">
                  Pipe and Drape Backgrounds
                </h3>
                <p className="text-white text-sm" data-id="element-895">
                  Step into the spotlight with our elegant selfie station,
                  complete with stylish pipe and drape setups to hold our green
                  screen. Perfect for adding a polished touch to your event
                  while capturing fun and memorable moments with virtual
                  backgrounds.
                </p>
              </div>
            </div>
            <div className="relative rounded-lg overflow-hidden group" data-id="element-896">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kTpurf8PZPNa884ZGhyeEP/20250222_151824740.jpg" alt="Family with digital backdrop" className="w-full h-[500px] object-cover" data-id="element-897" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-500/70 via-primary-500/40 to-transparent p-6 flex flex-col justify-end" data-id="element-898">
                <h3 className="text-white text-xl font-bold mb-2" data-id="element-899">
                  Customized Virtual Backgrounds
                </h3>
                <p className="text-white text-sm" data-id="element-900">
                  Take your photos to the next level with our green screen
                  technology and customizable virtual backgrounds! Choose from
                  themed settings or create a unique design for your event.
                  Transform every snapshot into a one-of-a-kind memory.
                </p>
              </div>
            </div>
            <div className="relative rounded-lg overflow-hidden group" data-id="element-901">
              <iframe src="https://www.youtube.com/embed/k9gxbGRtU_4?autoplay=1&mute=1&loop=1&playlist=k9gxbGRtU_4" title="Boomerangs and Videos" className="w-full h-[500px] object-cover absolute inset-0" style={{
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            }} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-902"></iframe>
              <div className="absolute inset-0 bg-gradient-to-t from-primary-500/70 via-primary-500/40 to-transparent p-6 flex flex-col justify-end" data-id="element-903">
                <h3 className="text-white text-xl font-bold mb-2" data-id="element-904">
                  Boomerangs and Videos
                </h3>
                <p className="text-white text-sm" data-id="element-905">
                  Add energy and excitement to your event with our boomerang and
                  video features! Capture playful loops and fun clips that bring
                  your favorite moments to life, perfect for sharing and
                  reliving the fun.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Features section */}
        <div className="mb-20" data-id="element-906">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-907">
            What Makes Our Photo Booth Special
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8" data-id="element-908">
            {features.map((feature, index) => <div key={index} className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-909">
                <div className="bg-primary-100 p-3 rounded-full inline-block mb-4" data-id="element-910">
                  <feature.icon className="h-6 w-6 text-primary-600" data-id="element-911" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-912">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-913">{feature.description}</p>
              </div>)}
          </div>
        </div>
        {/* Pricing section */}
        <div className="mb-20" data-id="element-914">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-915">
            Find The Perfect Fit For Your Budget
          </h2>
          <p className="text-center text-lg text-gray-600 mb-12 max-w-4xl mx-auto" data-id="element-916">
            Choose from our range of flexible pricing options that cater to your
            specific needs.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-917">
            {/* Package 1 */}
            <div className="bg-white rounded-lg shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition-all" data-id="element-918">
              <div className="p-6 text-center border-b border-gray-100" data-id="element-919">
                <h3 className="text-2xl font-bold text-primary-600" data-id="element-920">$50/hr</h3>
                <p className="uppercase font-semibold text-sm mt-2 text-gray-800" data-id="element-921">
                  Photo Booth Only
                </p>
              </div>
              <div className="p-6" data-id="element-922">
                <ul className="space-y-3" data-id="element-923">
                  <li className="flex items-start" data-id="element-924">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-925" />
                    <span data-id="element-926">Digital Individual Photos</span>
                  </li>
                  <li className="flex items-start" data-id="element-927">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-928" />
                    <span data-id="element-929">Plain Photo booth Template</span>
                  </li>
                  <li className="flex items-start" data-id="element-930">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-931" />
                    <span data-id="element-932">Digital Background with AI</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Package 2 */}
            <div className="bg-white rounded-lg shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition-all" data-id="element-933">
              <div className="p-6 text-center border-b border-gray-100" data-id="element-934">
                <h3 className="text-2xl font-bold text-primary-600" data-id="element-935">$55/hr</h3>
                <p className="uppercase font-semibold text-sm mt-2 text-gray-800" data-id="element-936">
                  Photo Booth + Backdrop
                </p>
              </div>
              <div className="p-6" data-id="element-937">
                <ul className="space-y-3" data-id="element-938">
                  <li className="flex items-start" data-id="element-939">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-940" />
                    <span data-id="element-941">Digital Individual Photos</span>
                  </li>
                  <li className="flex items-start" data-id="element-942">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-943" />
                    <span data-id="element-944">Plain Photo Booth Template</span>
                  </li>
                  <li className="flex items-start" data-id="element-945">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-946" />
                    <span data-id="element-947">White, Black, or Green Backdrop</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Package 3 */}
            <div className="bg-white rounded-lg shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition-all" data-id="element-948">
              <div className="p-6 text-center border-b border-gray-100" data-id="element-949">
                <h3 className="text-2xl font-bold text-primary-600" data-id="element-950">
                  $25 each
                </h3>
                <p className="uppercase font-semibold text-sm mt-2 text-gray-800" data-id="element-951">
                  Additional Customizations
                </p>
              </div>
              <div className="p-6" data-id="element-952">
                <ul className="space-y-3" data-id="element-953">
                  <li className="flex items-start" data-id="element-954">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-955" />
                    <span data-id="element-956">Customized Digital Background</span>
                  </li>
                  <li className="flex items-start" data-id="element-957">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-958" />
                    <span data-id="element-959">Customized Home Screens</span>
                  </li>
                  <li className="flex items-start" data-id="element-960">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-961" />
                    <span data-id="element-962">Customized Photo Booth Templates</span>
                  </li>
                  <li className="flex items-start" data-id="element-963">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-964" />
                    <span data-id="element-965">Green Screen for Virtual Backgrounds</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Package 4 */}
            <div className="bg-white rounded-lg shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition-all" data-id="element-966">
              <div className="p-6 text-center border-b border-gray-100" data-id="element-967">
                <h3 className="text-2xl font-bold text-primary-600" data-id="element-968">$150</h3>
                <p className="uppercase font-semibold text-sm mt-2 text-gray-800" data-id="element-969">
                  Photo Booth Only with Soft Play
                </p>
              </div>
              <div className="p-6" data-id="element-970">
                <ul className="space-y-3" data-id="element-971">
                  <li className="flex items-start" data-id="element-972">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-973" />
                    <span data-id="element-974">Digital Individual Photos</span>
                  </li>
                  <li className="flex items-start" data-id="element-975">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-976" />
                    <span data-id="element-977">Plain Photo Booth Template</span>
                  </li>
                  <li className="flex items-start" data-id="element-978">
                    <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-979" />
                    <span data-id="element-980">Digital Background with AI</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* How it works */}
        <div className="mb-20" data-id="element-981">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-982">
            How It Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-983">
            <div className="text-center p-6" data-id="element-984">
              <div className="bg-secondary-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-985">
                <span className="text-2xl font-bold text-secondary-600" data-id="element-986">1</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-987">
                Book Your Date
              </h3>
              <p className="text-gray-600" data-id="element-988">
                Contact us to check availability and reserve your photo booth
                for your special event.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-989">
              <div className="bg-secondary-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-990">
                <span className="text-2xl font-bold text-secondary-600" data-id="element-991">2</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-992">
                We Set Up
              </h3>
              <p className="text-gray-600" data-id="element-993">
                Our team will arrive early, set up the booth, and ensure
                everything is working perfectly.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-994">
              <div className="bg-secondary-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-995">
                <span className="text-2xl font-bold text-secondary-600" data-id="element-996">3</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-997">
                Enjoy!
              </h3>
              <p className="text-gray-600" data-id="element-998">
                Your guests enjoy capturing and sharing memories throughout your
                event.
              </p>
            </div>
          </div>
        </div>
        {/* CTA */}
        <div className="bg-primary-50 rounded-xl p-8 text-center" data-id="element-999">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1000">
            Create Magical Memories For Your Little Ones
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-1001">
            Book our toddler-friendly selfie station today and capture those
            precious smiles and silly faces that grow too quickly!
          </p>
          <Link to="/cart" className="inline-flex items-center px-8 py-4 bg-secondary-500 text-white rounded-md font-bold text-lg shadow-lg hover:bg-secondary-600 transition-all" onClick={() => window.scrollTo(0, 0)} data-id="element-1002">
            Book Now
          </Link>
        </div>
      </div>
    </div>;
};